export const sanitizeInputText = (s: string) => {
  return s
    .replace(/\u2028|\u2029/g, '\n') // line/para sep -> newline
    .replace(
      /[\u200B-\u200D\uFEFF\u200E\u200F\u061C\u202A-\u202E\u2066-\u2069]/g,
      '',
    ) // zero-width-spaces/BOM
}

export const DEFAULT_HUBSPOT_PHONE_NUMBER = '5555555555'
export const normalizeHubspotPhoneNumber = (phone: string | null) => {
  if (!phone) {
    return null
  }
  const match = phone.match(
    /(?:\+?1[\s-]*)?\(?(\d{3})\)?[\s.-]*(\d{3})[\s.-]*(\d{4})/,
  )

  return match ? match.slice(1).join('') : null
}
